var excluded = false;
var dryProduct = false; 
var specialProduct = false;
for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  if (itemTitle === 'Delivery Order Processing') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('shipping'.toLowerCase()) > -1) {
    excluded = true;
  } else {
    dryProduct = true;
  }

  /*if (itemCollections.toLowerCase().indexOf('Valentine\'s Day'.toLowerCase()) > -1) {
    specialProduct = true;
  }

  if (itemCollections.toLowerCase().indexOf('Shop Cakes'.toLowerCase()) > -1) {
    specialProduct = true;
  }

  if (itemCollections.toLowerCase().indexOf('Shop Deserts'.toLowerCase()) > -1) {
    specialProduct = true;
  }*/
}

if (specialProduct2 === false) {
  storePickupSettings.shippingEnabled = false;
} 
// not used anymore, the logic is in cart-template.liquid
/*if (specialProduct === false) {
  storePickupSettings.min_days = 3;
}*/
            
if (excluded === true && dryProduct === true) {
  console.log('Hide pickup')
}
document.addEventListener('crJQActivated', function (e) {
    console.log('*******************************')

    if (excluded === true && dryProduct === true) {
      disableCheckoutButton();
      jqCR('.pickup-button').hide();
      jqCR('.special-message').removeClass('hide')
      setTimeout(function(){
        jqCR('.cr-error').text("Some items in your cart cannot be shipped, please remove them")
        jqCR('.cr-shipping-method').click()
      }, 1000)
      
      var tt = setInterval(function(){disableCheckoutButton();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);   
    }  

  
  if (specialProduct2 === false) {	
  	jqCR('.cr-shipping-method').hide()
  } else {
    jqCR('#cr-shipping-container').show();
    jqCR('.delivery-method-desc').hide();
    setTimeout(function(){
      jqCR('.pickup-button').hide();
      jqCR('.cart').validate();
      jqCR('#shipping-date').rules('add', {required: true})    
    }, 200)
    
  }   
})
function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}


document.addEventListener('crDeliveryActivated', function (e) {
  jqCR('#cr-shipping-container').hide();
})


document.addEventListener('crPickupActivated', function (e) {
  jqCR('#cr-shipping-container').hide();
})